import RegisterForm from 'src/sections/auth/register-form';

export default function RegisterPage() {
  return <RegisterForm />;
}
